import { useCallback, useMemo, useReducer } from "react";

import { actions, INITIAL_STATE, reducer } from "./reducers/booking_checkout";

export default () => {
  const [bookingCheckoutData, dispatch] = useReducer(reducer, INITIAL_STATE);

  const createBooking = useCallback(
    (channelId, type, bookingData, bookingParams) => {
      return actions.createBooking(dispatch, channelId, type, bookingData, bookingParams);
    },
    [dispatch],
  );

  const setSubmitHandler = useCallback(
    (handler) => {
      return actions.setSubmitHandler(dispatch, handler);
    },
    [dispatch],
  );

  const startSubmit = useCallback(() => {
    actions.setFormSubmitting(dispatch);

    return bookingCheckoutData.submitHandler();
  }, [dispatch, bookingCheckoutData]);

  const setFormSubmitComplete = useCallback(() => {
    return actions.setFormSubmitComplete(dispatch);
  }, [dispatch]);

  const bookingCheckoutActions = useMemo(
    () => ({
      setSubmitHandler,
      createBooking,
      startSubmit,
      setFormSubmitComplete,
    }),
    [setSubmitHandler, createBooking, startSubmit, setFormSubmitComplete],
  );

  return useMemo(
    () => ({ bookingCheckoutData, bookingCheckoutActions }),
    [bookingCheckoutData, bookingCheckoutActions],
  );
};
